










import { Component, Vue } from 'vue-property-decorator';
import Form from '@/classes/Form';
import FormsTable from '@/components/FormsTable/FormsTable.vue';

@Component({components: {FormsTable}})
export default class ActionableForms extends Vue {
    get requests(): Form[] {
        return this.$store.getters.getFormsInNeedOfAction;
    }
}
